import { fontSizes } from "./font-sizes";
import { lineHeights } from "./line-heights";
import { fontWeights } from "./font-weights";
import { colors } from "./colors";
export var components = {
  text: {
    xl: {
      font: "sansSerif",
      fontSize: [fontSizes.mobile.xl, fontSizes.desktop.xl],
      lineHeight: [lineHeights.mobile.xl, lineHeights.desktop.xl],
      color: colors.gray[900],
      fontWeight: fontWeights.semibold
    },
    lg: {
      font: "sansSerif",
      fontSize: [fontSizes.mobile.lg, fontSizes.desktop.lg],
      lineHeight: [lineHeights.mobile.lg, lineHeights.desktop.lg],
      color: colors.gray[900],
      fontWeight: fontWeights.semibold
    },
    md: {
      font: "sansSerif",
      fontSize: [fontSizes.mobile.md, fontSizes.desktop.md],
      lineHeight: [lineHeights.mobile.md, lineHeights.desktop.md],
      color: colors.gray[900],
      fontWeight: fontWeights.semibold
    },
    sm: {
      font: "sansSerif",
      fontSize: [fontSizes.mobile.sm, fontSizes.desktop.sm],
      lineHeight: [lineHeights.mobile.sm, lineHeights.desktop.sm],
      color: colors.gray[900],
      fontWeight: fontWeights.semibold
    },
    xs: {
      font: "sansSerif",
      fontSize: [fontSizes.mobile.xs, fontSizes.desktop.xs],
      lineHeight: [lineHeights.mobile.xs, lineHeights.desktop.xs],
      color: colors.gray[900],
      fontWeight: fontWeights.semibold
    },
    heading: {
      font: "sansSerif",
      fontSize: [fontSizes.mobile.heading, fontSizes.desktop.heading],
      lineHeight: [lineHeights.mobile.heading, lineHeights.desktop.heading],
      color: colors.gray[900],
      fontWeight: fontWeights.semibold
    },
    subheading: {
      font: "sansSerif",
      fontSize: [fontSizes.mobile.subheading, fontSizes.desktop.subheading],
      lineHeight: [lineHeights.mobile.subheading, lineHeights.desktop.subheading],
      color: colors.gray[900],
      fontWeight: fontWeights.semibold
    },
    body: {
      font: "sansSerif",
      fontSize: [fontSizes.mobile.body, fontSizes.desktop.body],
      lineHeight: [lineHeights.mobile.body, lineHeights.desktop.body],
      color: colors.gray[900],
      fontWeight: fontWeights.semibold
    },
    small: {
      fontSize: [fontSizes.mobile.small, fontSizes.desktop.small],
      lineHeight: [lineHeights.mobile.small, lineHeights.desktop.small],
      color: colors.gray[900],
      fontWeight: fontWeights.semibold
    },
    code: {
      font: "monoSpaced",
      fontSize: [fontSizes.mobile.code, fontSizes.desktop.code],
      lineHeight: [lineHeights.mobile.code, lineHeights.desktop.code],
      color: colors.gray[900],
      fontWeight: fontWeights.semibold
    }
  }
};